import React from 'react';
import PropTypes from 'prop-types';

export const Attach = ({ width, height, ...props }) => (
  <svg
    data-icon='attach'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M18 15.75c0 1.733-.608 3.208-1.825 4.425C14.958 21.392 13.483 22 11.75 22c-1.733 0-3.208-.608-4.425-1.825C6.108 18.958 5.5 17.483 5.5 15.75V6.5c0-1.25.438-2.313 1.313-3.188C7.688 2.438 8.75 2 10 2c1.25 0 2.313.438 3.188 1.313.874.874 1.312 1.937 1.312 3.187v8.75c0 .767-.267 1.417-.8 1.95-.533.533-1.183.8-1.95.8a2.654 2.654 0 0 1-1.95-.8 2.653 2.653 0 0 1-.8-1.95V6h2v9.25a.728.728 0 0 0 .75.75.728.728 0 0 0 .75-.75V6.5c-.017-.7-.262-1.292-.738-1.775C11.287 4.242 10.7 4 10 4s-1.292.242-1.775.725C7.742 5.208 7.5 5.8 7.5 6.5v9.25c-.017 1.183.392 2.188 1.225 3.012.833.825 1.842 1.238 3.025 1.238 1.167 0 2.158-.413 2.975-1.238.817-.825 1.242-1.829 1.275-3.012V6h2v9.75Z'
    />
  </svg>
);

Attach.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Attach.defaultProps = {
  width: 24,
  height: 24,
};
